import { KEGatewayClient } from '../KEGatewayClient';
import type { IGetLegalCustomersResponse, IGetLegalCustomerInfoResponse, ILoginAsLegalResponse, LegalCustomer, IAddLegalCompanyResponse, IAddLegalCompanyRequest } from './model';

export class LegalClient extends KEGatewayClient {
  public async getLegalCustomers(): Promise<LegalCustomer[]> {
    const response = await this.get<IGetLegalCustomersResponse>('customer/legal/all');
    return response.payload;
  }

  public async loginAsLegal(legalId: number): Promise<{ accessToken: string; refreshToken: string }> {
    const response = await this.get<ILoginAsLegalResponse>('customer/legal/token', {
      searchParams: { legalCustomerId: legalId },
    });

    return response.payload;
  }

  public async getLegalCustomerInfo(legalId: number): Promise<LegalCustomer> {
    const response = await this.get<IGetLegalCustomerInfoResponse>('customer/legal', {
      searchParams: { legalCustomerId: legalId },
    });

    return response.payload;
  }

  public async addLegalCompany(request: IAddLegalCompanyRequest): Promise<IAddLegalCompanyResponse> {
    const response = await this.post<IAddLegalCompanyResponse>('customer/legal/add', {
      ...request,
    });

    return response;
  }
}